import { actionCreator } from '@ardoq/rxbeach';

export const exportToPlantUml = actionCreator<{ isViewpointMode: boolean }>(
  '[PlantUML] EXPORT_TO_PLANTUML'
);
